import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from './Button';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(20, 32, 63, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 16px;
`;

const Panel = styled.div`
  background: #fff;
  border-radius: 12px;
  max-width: 440px;
  padding: 24px;

  h3 {
    margin: 0 0 8px;
  }
  p {
    margin: 0 0 16px;
    color: #64708f;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const UpgradePrompt: FC = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const onLimit = (event: any) => setMessage((event.detail && event.detail.message) || '');
    window.addEventListener('free-plan-limit', onLimit);
    return () => window.removeEventListener('free-plan-limit', onLimit);
  }, []);

  if (!message) return null;

  return (
    <Backdrop role="dialog" aria-modal="true" aria-labelledby="upgradePromptTitle">
      <Panel>
        <h3 id="upgradePromptTitle">You have reached a Free Plan limit</h3>
        <p>{message}</p>
        <Row>
          <Button
            bg="success"
            text="See plans"
            type="button"
            onClick={() => window.open('https://www.impactboard.tech/pricing', '_blank')}
          />
          <Button bg="grey" text="Not now" type="button" onClick={() => setMessage('')} />
        </Row>
      </Panel>
    </Backdrop>
  );
};

export default UpgradePrompt;
